import { range } from 'lodash';
import React from 'react';
import Table from '@splunk/dashboard-visualizations/Table';

export default () => (
    <Table
        width={800}
        height={200}
        options={{}}
        encoding={{
            columns: ['primary.foo', 'primary.bar'],
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'foo' }, { name: 'bar' }],
                    columns: [range(10), range(10)],
                },
                meta: { totalCount: 100 },
            },
        }}
    />
);
